import { render, staticRenderFns } from "./ArchivesManagementModal.vue?vue&type=template&id=743e09b5&"
import script from "./ArchivesManagementModal.vue?vue&type=script&lang=js&"
export * from "./ArchivesManagementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports